@let user = user$ | async;

<a class="skip-link" href="#main">{{ 'common.skipToContent' | translate }}</a>

<app-header></app-header>
@if (user) {
  <!-- Signed in: app shell with the Apple sidebar -->
  <app-layout>
    <!-- Admin nudge: install the PWA / enable push (renders only when relevant) -->
    <app-push-prompt></app-push-prompt>
    <main id="main" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
  </app-layout>
  <!-- Live in-app notification toasts (realtime arrivals) -->
  <app-notification-toast></app-notification-toast>
} @else {
  <!-- Signed out: no sidebar, full-width content + top nav. The shared
       <app-footer> renders on every page (incl. the landing) for consistency. -->
  <main id="main" tabindex="-1">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
}

<!-- Action feedback (snackbars) — always mounted -->
<app-snackbar-host></app-snackbar-host>

<!-- Analytics consent banner (shows once, until a choice is stored) -->
<app-cookie-consent></app-cookie-consent>
